import type { ModuleRoute } from '../types';
import { FormPage } from './FormPage';
import { PrivacyPage } from './PrivacyPage';
import { ExportPage, RequestStatusPage } from './RequestPages';

/**
 * Pages of this area (public pages on the link host: pre-registration forms, privacy page and data requests, request
 * status and export download). `/d/` and `/x/` are LINK_KINDS (packages/shared/src/links.ts); `/:tenantSlug/forms/:slug`
 * and `/:tenantSlug/privacy` are addressed by tenant slug. Owned by Phase 4 task W29; only that task edits files in this
 * folder (W32 wires it last).
 */
export const routes: ModuleRoute[] = [
  { path: '/:tenantSlug/forms/:slug', element: <FormPage />, public: true, area: 'any' },
  { path: '/:tenantSlug/privacy', element: <PrivacyPage />, public: true, area: 'any' },
  { path: '/d/:token', element: <RequestStatusPage />, public: true, area: 'any' },
  { path: '/x/:token', element: <ExportPage />, public: true, area: 'any' },
];
